import React from 'react'

import NavBar from '../NavBar';
import { useUser } from '../../contexts/user';
import Footer from '../Footer';

function Layout(props) {

  const { logout, user } = useUser();

  return (
    <>
      <NavBar user={user} handleSignout={logout} />

      <div>
        {props.children}
      </div>

      <Footer />
    </>
  )
}


export default Layout
